import {
  ChatterBreakpoint,
  ChatterConfig as IChatterConfig
} from 'services/api-service'

export class ChatterConfig implements IChatterConfig {
  constructor(config: IChatterConfig) {
    this.breakpointsConfig = config.breakpointsConfig
    this.headingLevel = config.headingLevel || 2
    this.limit = config.limit
    this.minCount = config.minCount
    this.minCharacterCount = config.minCharacterCount
    this.minWordCount = config.minWordCount
    this.truncateLength = config.truncateLength
    this.truncateAllowance = config.truncateAllowance
    this.includeSyndicated = config.includeSyndicated
    this.sortOrder = config.sortOrder
    this.widgetDivId = config.widgetDivId
  }

  breakpointsConfig: Array<ChatterBreakpoint>
  headingLevel: number
  includeSyndicated: boolean
  limit: number
  minCount: number
  minCharacterCount: number
  minWordCount: number
  sortOrder: number
  // the number of characters more than truncateLength it is allowed to be before we
  // really do truncate for when we want default to be true, 2nd check makes sure we ignore
  // any value they might have given like 3 or abc
  truncateAllowance: number
  truncateLength: number
  widgetDivId: string
}

let defaultConfig: IChatterConfig = {}
export function loadConfig(config: IChatterConfig): void {
  defaultConfig = new ChatterConfig(config)
}
export { defaultConfig as default }
